module.exports = __webpack_public_path__ + "static/media/cq_minus.8da0bcfd.svg";